import { computed } from "vue";

const colors = {
    "blue": "blue-btn",
    "orange": "orange-btn",
    "light-orange": "light-orange-btn"
}

export const buttonBackgroundColor = computed(() => {
    return (color) => {
        let buttonClass = colors[color];
        return buttonClass;
    }
})